import { FilterIncExcToggle } from '../baseInputTypes/FilterIncExcToggle'

export const Providers = () => (
  <FilterIncExcToggle
    label="Provider"
    fieldName={'providers'}
    valuesFieldPath={'mediaDetails.provider'}
    modeFieldPath={'mediaDetails.providerMode'}
  />
)
